<template>
  <div class="staging-page">
    <div class="content-area">
      <!-- 统计卡片行 -->
      <div class="stats-row">
        <div class="stat-card" v-for="(item, index) in statsList" :key="index">
          <div class="stat-icon">
            <img :src="item.icon" alt="" />
          </div>
          <div class="stat-info">
            <div class="stat-value-row">
              <span class="stat-value">{{ item.value }}</span>
              <span class="stat-unit">{{ item.unit }}</span>
            </div>
            <div class="stat-label">{{ item.label }}</div>
          </div>
        </div>
      </div>

      <!-- 最近融资 -->
      <div class="recent-finance">
        <div class="section-header">
          <div class="section-title">
            <span class="title-bar" />
            最近融资
          </div>
          <div class="section-more" @click="toRoute('lendingTransactions')">
            全部 <i class="el-icon-arrow-right" />
          </div>
        </div>
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width: 65px;">序号</th>
                <th style="width: 131px;">贷款名称</th>
                <th style="width: 131px;">贷款额度</th>
                <th style="width: 131px;">贷款期限</th>
                <th style="width: 131px;">年利率范围</th>
                <th style="width: 131px;">担保方式</th>
                <th style="width: 131px;">信贷类型</th>
                <th style="width: 150px;">客户经理</th>
                <th style="width: 131px;">联系电话</th>
                <th>产品描述</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, idx) in tableData" :key="row.id || idx">
                <td>{{ idx + 1 }}</td>
                <td>{{ row.cpmc }}</td>
                <td>{{ row.dkedxx }} ~ {{ row.dkedsx }}万元</td>
                <td>{{ row.dkqxxx }} ~ {{ row.dkqxsx }}月</td>
                <td>{{ row.zdnhlv }}% ~ {{ row.zgnhlv }}%</td>
                <td>{{ row.dbfsm }}</td>
                <td>{{ row.dklxm }}</td>
                <td>{{ row.khjl }}</td>
                <td>{{ row.lxrdh }}</td>
                <td>
                  <el-popover placement="top-start" width="260" trigger="hover">
                    <div class="table-popover" v-html="row.cpms" />
                    <div slot="reference" class="table-text">{{ row.cpms }}</div>
                  </el-popover>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* 图片导入 */
import statProduct from "@/assets/img/2026/bar-3.png";
import statEnterprise from "@/assets/img/2026/bar-2.png";
import statAmount from "@/assets/img/2026/bar-6.png";

/* API 导入 */
import { getStaging, getRecentlyOrder } from "../viewApi";

export default {
  name: "staging",
  data() {
    return {
      tableData: [],
      statsList: [],
    };
  },
  created() {
    this.queryData();
    this.queryTableData();
  },
  methods: {
    /** 获取统计数据 */
    queryData() {
      getStaging().then((res) => {
        if (res.code === 1000) {
          this.statsList = [
            {
              icon: statProduct,
              value: res.data.productCount || 0,
              unit: "个",
              label: "发布产品数",
            },
            {
              icon: statEnterprise,
              value: res.data.serviceEnterprise || 0,
              unit: "家",
              label: "服务企业",
            },
            {
              icon: statAmount,
              value: res.data.sumMoney || "0.00",
              unit: "万元",
              label: "累计放款金额",
            },
          ];
        }
      });
    },

    /** 获取最近融资列表 */
    queryTableData() {
      const param = { size: 10, total: 0, current: 1 };
      getRecentlyOrder(param).then((res) => {
        if (res.code === 1000) {
          this.tableData = res.data.records;
        }
      });
    },

    /** 路由跳转 */
    toRoute(name) {
      if (name === this.$route.name) return;
      this.$router.push({ name });
    },
  },
};
</script>

<style scoped lang="scss">
.staging-page {
  // min-height: calc(100vh - 70px);
}

/* 右侧内容区 */
.content-area {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 统计卡片行 */
.stats-row {
  display: flex;
  background: #ffffff;
  border-radius: 16px;
}

.stat-card {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  padding: 20px 12px;
}

.stat-icon {
  width: 98px;
  height: 98px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.stat-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.stat-value-row {
  display: flex;
  align-items: flex-end;
  gap: 2px;
}

.stat-value {
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 36px;
  line-height: 20px;
  color: #1366ec;
}

.stat-unit {
  font-family: "Noto Sans SC", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.5);
}

.stat-label {
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.9);
}

/* 最近融资 */
.recent-finance {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 5px 5px 0 rgba(54, 97, 167, 0.05);
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 7px;
}

.title-bar {
  width: 5px;
  height: 16px;
  background: #1366ec;
  border-radius: 16px;
}

.section-title span:last-child {
  font-family: "PingFang SC", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
}

.section-more {
  font-family: "Noto Sans SC", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #1366ec;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 2px;

  i {
    font-size: 14px;
  }

  &:hover {
    opacity: 0.8;
  }
}

/* 自定义表格 */
.table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  thead th {
    background: #f8f8fa;
    border: 1px solid #e5e5e5;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 15px 10px;
    font-family: "PingFang SC", sans-serif;
    font-weight: 600;
    font-size: 14px;
    color: #909399;
    text-align: center;
    white-space: nowrap;
  }

  tbody td {
    border: 1px solid #e5e5e5;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 15px 10px;
    font-family: "PingFang SC", sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    text-align: center;
  }
}

.table-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 120px;
  cursor: pointer;
  display: inline-block;
}

.table-popover {
  max-height: 200px;
  overflow-y: auto;
  font-size: 13px;
  line-height: 1.6;
  color: #606266;
}
</style>
